<div class="row narrow-gutters mb-2">
  @if (!!summary.releaseStatus.status) {
    <div class="col-md-auto">
      <span class="btn-group dropup mx-1 always-enabled">
        <button class="btn btn-outline-secondary dropdown-toggle py-1" style="min-width: 7rem" type="button"
                data-bs-toggle="dropdown">Incoming
          <span class="caret"></span></button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li (click)="utils.fetchProcessIdAndOpenMessageManagement('coreor-in-' + summary.id)"
                class="dropdown-item">Commercial release from carrier</li>
          </ul>
        </span>
    </div>
  }
  @if (!!summary.releaseStatus.status) {
    <div class="col-md-auto ms-auto">
        <span class="btn-group dropup mx-1 always-enabled">
          <button class="btn btn-outline-secondary dropdown-toggle py-1" style="min-width: 7rem" type="button"
                  data-bs-toggle="dropdown">Outgoing
            <span class="caret"></span></button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li (click)="utils.fetchCoreorOutProcessIdAndOpenMessageManagement(summary.id)"
                  class="dropdown-item">Commercial release to terminal</li>
            </ul>
          </span>
    </div>
  }

  @if (adminAllowedToManipulateCR()) {
    <div class="col-md-auto">
      <app-confirmation-toggle>
        <button class="btn btn-outline-secondary py-1" style="min-width: 7rem" type="button">Resubmit</button>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Resubmit release</h5>
          </div>
          <div class="modal-body">
            <p>Are you sure that you want to resubmit this release as admin?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
          </div>
        </div>
      </app-confirmation-toggle>
    </div>
  }

  @if (adminAllowedToManipulateCR()) {
    <div class="col-md-auto">
      <app-confirmation-toggle>
        <button class="btn btn-outline-success py-1" style="min-width: 7rem" type="button">Accept</button>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Accept release</h5>
          </div>
          <div class="modal-body">
            <p>Are you sure that you want to accept this release as admin?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="acceptRelease()">Yes
            </button>
          </div>
        </div>
      </app-confirmation-toggle>
    </div>
  }

  @if (adminAllowedToManipulateCR()) {
    <div class="col-md-auto">
      <app-confirmation-toggle>
        <button class="btn btn-outline-danger py-1" style="min-width: 7rem" type="button">Reject</button>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Reject release</h5>
          </div>
          <div class="modal-body">
            <input class="form-control" required placeholder="Enter reasons" [(ngModel)]="rejectionReasons">
            <p>Are you sure that you want to reject this release as admin?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="rejectRelease()">Yes
            </button>
          </div>
        </div>
      </app-confirmation-toggle>
    </div>
  }
</div>
